var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 18v4h27v-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B363B",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M2 18v4h27v-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B363B",
    stroke: "#2B363B",
    d: "M16.982 10.901v.5h4.263c.22 0 .363.287.153.47l-.004.004-6.235 5.562-.003.002a.246.246 0 0 1-.324 0l-.002-.002-6.236-5.562-.004-.004a.257.257 0 0 1-.071-.296.248.248 0 0 1 .24-.174h4.279V.887c0-.224.173-.387.37-.387h3.204c.197 0 .37.163.37.387v10.014Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.260e662c0286dca1757924c8c8e8981a.svg";
export { ForwardRef as ReactComponent };